import { render } from "./Greeting.vue?vue&type=template&id=211608c4"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Greeting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/globals/Greeting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "211608c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('211608c4', __exports__)) {
    console.log('reload')
    api.reload('211608c4', __exports__)
  }
  
  module.hot.accept("./Greeting.vue?vue&type=template&id=211608c4", () => {
    console.log('re-render')
    api.rerender('211608c4', render)
  })

}


export default __exports__